app.service('store', function (productCardConfig, localStorage, hashChecker, productCardManager, console) {

	let observers = [];

	let config;

	let store = {
		context: {
			isInstalment: false,
			code: null,
			number: null,
			paymentType: null,
			instalmentWarrantyId: null
		},
		state: {
			isOutlet: false,
			outletCategoryId: null
		},
	};

	let mutations = {
		setStandardContext() {
			store.context = {
				isInstalment: false,
				code: null,
				number: null,
				paymentType: null,
				instalmentWarrantyId: null
			};
			localStorage.removeItem('KP_INSTALMENT_CONTEXT');
		},
		setInstalmentContext(payload) {
			store.context = {
				isInstalment: true,
				number: payload.number,
				code: payload.code,
				paymentType: payload.paymentType,
				instalmentWarrantyId: payload.instalmentWarrantyId
			};
			localStorage.setItem('KP_INSTALMENT_CONTEXT', 'true');
		},
		setNewState() {
			productCardManager.empty();

			store.state = {
				isOutlet: false,
				outletCategoryId: null
			};
			productCardManager.empty();
		},
		setOutletState(payload) {
			if (!store.state.outletCategoryId) {
				productCardManager.empty();
			}

			store.state = {
				isOutlet: true,
				outletCategoryId: parseInt(payload.outletCategoryId)
			};
		}
	};

	let actions = {
		setStandardContext() {
			commit('setStandardContext');
		},
		setDefaultContext() {
			if (config.defaultInstalmentOption.available) {
				const data = $.extend({}, config.defaultInstalmentOption);
				commit('setInstalmentContext', data);
			} else {
				commit('setStandardContext');
			}
		},
		setNewState() {
			commit('setStandardContext');
			commit('setNewState');
		},
		setDefaultOutlet() {
			if (config.availableOutletCategories.length === 0) return;

			const {outletCategoryId} = config.availableOutletCategories[0];
			commit('setOutletState', {outletCategoryId})
		},
		setDefaultOutletContext(payload) {
			if (config.availableOutletCategories.length === 0) return;

			const outletCategoryId = payload.outletCategoryId;

			const {defaultInstalmentOption} = config.availableOutletCategories
				.find(option => parseInt(option.outletCategoryId) === parseInt(outletCategoryId));

			if (defaultInstalmentOption.available) {

				const data = $.extend({}, defaultInstalmentOption);
				commit('setInstalmentContext', data);
			} else {
				commit('setStandardContext');
			}

			commit('setOutletState', {outletCategoryId})
		},
		setOutletState(payload) {
			commit('setStandardContext');
			commit('setOutletState', {
				outletCategoryId: payload.outletCategoryId
			});
		},
		setOutletByLinkName(payload) {
			if (config.availableOutletCategories.length === 0) return;

			const {outletCategoryId} = config.availableOutletCategories.find(category => category.linkName === payload.linkName) || {outletCategoryId: null};
			commit('setOutletState', {
				outletCategoryId
			});
		},
		setOutletByLinkNameWithDefaultContext(payload) {
			if (config.availableOutletCategories.length === 0) return;

			const {outletCategoryId, defaultInstalmentOption} = config.availableOutletCategories.find(category => category.linkName === payload.linkName);
			const {code, number, paymentType} = defaultInstalmentOption;

			commit('setInstalmentContext', {code, number, paymentType});
			commit('setOutletState', {
				outletCategoryId
			});
		},
		changeInstalment(payload) {
			commit('setInstalmentContext', payload);
		}
	};

	function init() {
		const productDetailConfig = productCardConfig.getData();
		config = productDetailConfig.configurationDto;

		if (hashChecker.check(dispatch)) return;

		if (config.defaultSelectedOutletCategoryId) {
			dispatch('setOutletState', {
				outletCategoryId: config.defaultSelectedOutletCategoryId
			});
			return;
		}

		if (localStorage.getItem('KP_INSTALMENT_CONTEXT')) {
			dispatch('setDefaultContext');
		}
	}

	function dispatch(actionType, payload) {
		actions[actionType](payload);
		notify();
		// debugging
		// console.log(actionType, store.context, store.state);
	}

	function notify() {
		observers.forEach(callback => callback());
	}

	function commit(mutation, payload) {
		mutations[mutation](payload);
	}

	function onChange(fn) {
		observers.push(fn);
	}

	return {
		init,
		get data() {
			return {
				isOutlet: store.state.isOutlet,
				isInstalment: store.context.isInstalment,
				outletCategoryId: store.state.outletCategoryId,
				instalmentCode: store.context.code,
				instalmentNumber: store.context.number,
				instalmentPaymentType: store.context.paymentType,
				instalmentWarrantyId: store.context.instalmentWarrantyId
			}
		},
		dispatch,
		onChange
	};
});
